module.exports = __webpack_public_path__ + "static/media/color2.b383ea8b.jpg";